import React from 'react';
import {Container, Typography, CircularProgress, useTheme} from '@mui/material';
import SchoolIcon from "@mui/icons-material/School";

const Loader = () => {

    const theme = useTheme();

    return (
        <Container sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
            gap: 1
        }}>
            <SchoolIcon sx={{ fontSize: 40, color: theme.palette.primary.main }} />
            <Typography variant="subtitle1" component="h1" color="primary" fontWeight={450}>
                ClassCapture
            </Typography>
            <CircularProgress color="primary" size={24} />
        </Container>
    );
};

export default Loader;
